import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { Col, Container, Row } from "react-bootstrap";
import PageBanner from "../../components/PageBanner/PageBanner";
import "./Technologies.css";
import AngularLogo from "../../assets/img/technologies/angularJS.png";
import ReactLogo from "../../assets/img/technologies/reactJS.png";
import ReactNativeLogo from "../../assets/img/technologies/reactNative.png";
import NodeLogo from "../../assets/img/technologies/nodeJS.png";
import MongoLogo from "../../assets/img/technologies/mongoDB.png";
import PhpLogo from "../../assets/img/technologies/php.png";
import WordpressLogo from "../../assets/img/technologies/wordpress.png";
import DotNetLogo from "../../assets/img/technologies/DotNet.png";
import SqlServerLogo from "../../assets/img/technologies/sqlServer.png";
import AndroidLogo from "../../assets/img/technologies/android.png";
import IosLogo from "../../assets/img/technologies/ios.png";
import NextJsLogo from "../../assets/img/technologies/nextJS.png";
import OracleLogo from "../../assets/img/technologies/oracle.png";
import WorkWithUsPageBanner from "../../assets/img/services-banner/technologies-banner.png";
import CommonContactSection from "../Services/CommonContactSection/CommonContactSection";

function Technologies() {
  return (
    <>
      <Navbar />
      <PageBanner bgImage={WorkWithUsPageBanner} />
      <section className="py-lg-5 py-4">
        <Container fluid className="position-relative px-lg-5">
          <Row className="align-items-center justify-content-center">
            <Col lg={12} className="text-center">
              <p className="main-text text-center wow animate__animated animate__fadeInUp mb-5">
                We're more than just a technology firm—we're your partners in
                progress, bringing a diverse array of tech solutions to your
                fingertips. From groundbreaking software development to seamless
                user experiences and transformative digital strategies, we're
                here to empower you in every technological aspect.
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={ReactLogo}
                    alt=""
                  ></img>
                  <p>
                    React is a JavaScript library for building user interfaces,
                    developed by Facebook. It allows developers to create
                    interactive and dynamic UIs by using a declarative syntax.
                    React's key feature is its component-based architecture,
                    enabling the creation of reusable and modular UI elements.
                    Virtual DOM optimization enhances performance by minimizing
                    direct manipulation of the actual DOM.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={ReactNativeLogo}
                    alt=""
                  ></img>
                  <p>
                    React Native is a framework for building mobile applications
                    using React. Developed by Facebook, it enables the creation
                    of cross-platform apps with a single codebase, allowing
                    developers to use React principles for both iOS and Android
                    platforms. Leveraging native components, React Native offers
                    a native-like performance and user experience.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={NodeLogo}
                    alt=""
                  ></img>
                  <p>
                    Node.js is a server-side JavaScript runtime environment
                    built on Chrome's V8 JavaScript engine. It allows developers
                    to execute JavaScript code outside the browser, enabling
                    server-side scripting. Known for its event-driven,
                    non-blocking I/O model, Node.js is particularly adept at
                    handling concurrent connections efficiently.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={MongoLogo}
                    alt=""
                  ></img>
                  <p>
                    MongoDB is a popular NoSQL database that stores data in
                    flexible, JSON-like documents. It is designed to handle
                    large volumes of unstructured data, making it well-suited
                    for dynamic and scalable applications. MongoDB's schema-less
                    nature allows for easy adaptability as data structures
                    evolve. It supports dynamic queries, indexing, and provides
                    horizontal scalability through sharding.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={AngularLogo}
                    alt=""
                  ></img>
                  <p>
                    Angular is a robust open-source front-end web application
                    framework maintained by Google. It enables the development
                    of dynamic and single-page applications with a structured
                    architecture. Based on TypeScript, Angular offers strong
                    typing, making code more maintainable and scalable. Its
                    modular design encourages the creation of reusable
                    components, providing a clear separation of concerns.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={WordpressLogo}
                    alt=""
                  ></img>
                  <p>
                    WordPress is a popular open-source content management system
                    (CMS) widely used for creating websites and blogs. Known for
                    its user-friendly interface, it allows individuals and
                    businesses to easily manage and publish content without
                    extensive technical expertise. WordPress supports a vast
                    ecosystem of plugins and themes, enabling customization and
                    functionality expansion.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={PhpLogo}
                    alt=""
                  ></img>
                  <p>
                    PHP (Hypertext Preprocessor) is a server-side scripting
                    language widely used for web development. It is embedded in
                    HTML and executed on the server, generating dynamic content.
                    PHP is open-source and supports a broad range of databases,
                    making it a versatile choice for building dynamic websites
                    and web applications. Its simplicity, flexibility, and wide
                    adoption contribute to its enduring popularity.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={DotNetLogo}
                    alt=""
                  ></img>
                  <p>
                    .NET is a comprehensive framework developed by Microsoft,
                    facilitating the creation of a variety of applications,
                    including web, desktop, and mobile. It supports multiple
                    programming languages such as C#, F#, and Visual Basic,
                    promoting language interoperability. .NET encompasses a
                    runtime environment, class libraries, and development tools,
                    fostering efficient application development and maintenance.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={SqlServerLogo}
                    alt=""
                  ></img>
                  <p>
                    SQL Server, developed by Microsoft, is a relational database
                    management system (RDBMS) that excels in managing and
                    organizing structured data. It supports the SQL language for
                    querying, updating, and managing databases. SQL Server
                    offers robust features such as transaction control, data
                    integrity, and built-in security mechanisms. It is widely
                    used in enterprise environments for its scalability,
                    performance optimization tools, and seamless integration
                    with other Microsoft products.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>

            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={AndroidLogo}
                    alt=""
                  ></img>
                  <p>
                    Android is a mobile operating system developed by Google,
                    designed primarily for touchscreen devices such as
                    smartphones and tablets. It is built on a Linux kernel and
                    utilizes a customized version of the Java programming
                    language. Android has become the most widely used mobile
                    platform globally, powering a diverse range of
                    devices.Android runs on a wide range of devices manufactured
                    by different vendors. This diversity offers users various
                    options in terms of hardware specifications, form factors,
                    and price points.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={IosLogo}
                    alt=""
                  ></img>
                  <p>
                    iOS is a sophisticated and secure mobile operating system
                    renowned for powering a range of Apple devices, including
                    iPhones, iPads, iPod Touches, and Apple Watches. Known for
                    its sleek design, intuitive user interface, and seamless
                    ecosystem integration, iOS provides users with a premium and
                    cohesive digital experience. iOS's commitment to innovation
                    is reflected in features like Face ID, Touch ID, and ARKit,
                    making it a benchmark for mobile operating systems globally.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={NextJsLogo}
                    alt=""
                  ></img>
                  <p>
                    Next.js is a powerful and popular React framework for
                    building web applications. It enables developers to create
                    fast and SEO-friendly web applications with ease. Next.js
                    supports both static site generation and dynamic
                    server-rendered pages, offering flexibility for various
                    project requirements. With its rich ecosystem, including
                    plugins and a strong community, Next.js is widely adopted
                    for developing modern, high-performance React applications,
                    providing a streamlined and enjoyable development process.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
            <Col md={6} lg={4} className="mb-5">
              <div className="technologies-card text-center">
                <div className="technologies-card-content">
                  <img
                    className="img-fluid w-100 mb-3"
                    src={OracleLogo}
                    alt=""
                  ></img>
                  <p>
                    Oracle is a leading technology company known for its
                    comprehensive suite of database management systems, cloud
                    services, and enterprise software solutions. Oracle's
                    flagship product, Oracle Database, is a widely used
                    relational database management system (RDBMS) known for its
                    scalability, security, and robust features. The company has
                    also expanded its portfolio to include cloud infrastructure
                    and platform services, offering businesses a range of
                    solutions for data storage, analytics, and application
                    development.
                  </p>
                  {/* <a href="" className="btn btn-dark">
                    Read More
                  </a> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <CommonContactSection />
      <Footer />
    </>
  );
}

export default Technologies;
